export default __webpack_public_path__ + "static/media/camvdo.5d762615.mp4";